import { useEffect, useState } from "react"
import { toLowerCaseBlur } from "../../../helpers/functions"
import { ValidateErrorsBox } from "../../../../../components/ValidateErrorsBox"
import { useValidateLetters } from "../../../../../hooks/useValidateLetters"
import Form from "../../../../../components/Form"
import ResultLabel from "../../../../../components/ResultLabel"
import SectionTitle from "../../../../../components/SectionTitle"
import ObjectiveBox from "../../../../../components/ObjectiveBox"
import FieldGroup from "../../../../../components/FieldGroup"

const NomeFormSiteLP = ({ data }) => {
   const dataToDisplay = {
      _bowe: "bw",
      _canal: data.plataformaAutomacao.canal,
      _etapaFunil: data.plataformaAutomacao.etapaFunilPlataformas,
      _nomeProduto: data.geral[0].produtos,
      _tipoMaterial: data.plataformaAutomacao.tipoMaterialRicoAds,
   }

   const { errorsList, validateLetters, blockSpecialChars } = useValidateLetters()

   const [bowe, setBowe] = useState(dataToDisplay._bowe)
   const [etapaFunil, setEtapaFunil] = useState(dataToDisplay._etapaFunil[0])
   const [canal, setCanal] = useState(dataToDisplay._canal[0])
   const [nomeProduto, setNomeProduto] = useState("")
   const [tipoMaterialRico, setTipoMaterialRico] = useState(dataToDisplay._tipoMaterial[0])
   const [nomeFormulario, setNomeFormulario] = useState("")

   const [mrFieldActive, setMrFieldActive] = useState(false)

   useEffect(() => {
      if (etapaFunil === "tofu_mr" || etapaFunil === "mofu_mr" || etapaFunil === "bofu_mr") {
         setMrFieldActive(true)
      } else {
         setMrFieldActive(false)
      }
   }, [etapaFunil])

   return (
      <section id="form-lp-site">
         <SectionTitle>Nome de Formulário de LP e Site</SectionTitle>
         <ObjectiveBox>Padrão pra criação de nome de formulário no CRM (Hubspot, Marketo, RD...)</ObjectiveBox>
         {errorsList.length > 0 && <ValidateErrorsBox list={errorsList} />}

         <Form>
            <FieldGroup
               as="input"
               label="bw (bowe) *"
               onChange={({ target }) => setBowe(target.value)}
               value={bowe}
               onBlur={(e) => toLowerCaseBlur(bowe, setBowe)}
            />

            <FieldGroup
               as="select"
               label="Etapa do Funil *"
               onChange={({ target }) => setEtapaFunil(target.value)}
               value={etapaFunil}
               options={dataToDisplay._etapaFunil}
            />

            <FieldGroup
               as="select"
               label="Canal *"
               onChange={({ target }) => setCanal(target.value)}
               value={canal}
               options={dataToDisplay._canal}
            />

            <FieldGroup
               as="input"
               label="Nome do Produto *"
               onChange={({ target }) => {
                  setNomeProduto(target.value)
               }}
               value={nomeProduto}
               onKeyDown={(e) => {
                  blockSpecialChars(e)
               }}
               onBlur={(e) => validateLetters(e, setNomeProduto, "Nome do Produto *")}
            />

            {mrFieldActive && (
               <FieldGroup
                  as="select"
                  label="Tipo de Material Rico *"
                  onChange={({ target }) => setTipoMaterialRico(target.value)}
                  value={tipoMaterialRico}
                  options={dataToDisplay._tipoMaterial}
               />
            )}

            <FieldGroup
               as="input"
               label="Nome do Formulário *"
               value={nomeFormulario}
               onChange={({ target }) => setNomeFormulario(target.value)}
               onKeyDown={(e) => {
                  blockSpecialChars(e)
               }}
               onBlur={(e) => validateLetters(e, setNomeFormulario, "Nome do Formulário *")}
            />
         </Form>

         <ResultLabel disabled={errorsList.length > 0}>
            {`${bowe}_${etapaFunil}_${canal}_${nomeProduto}_${
               tipoMaterialRico ? `${tipoMaterialRico}_` : ""
            }${nomeFormulario}`}
         </ResultLabel>
      </section>
   )
}

export default NomeFormSiteLP
